"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _slice = require("@lce/slice");

var _api = require("@lce/api");

var _Handle = _interopRequireDefault(require("../Handle"));

var _Links = _interopRequireDefault(require("../Links"));

var _Links2 = require("../Links.data");

var Styled = _interopRequireWildcard(require("./Popover.style"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var Popover = function Popover() {
  var isAuthenticated = (0, _api.useAuthenticated)();

  var _a = (0, _react.useState)(false),
      isOpen = _a[0],
      setIsOpen = _a[1];

  var handleOnClose = function handleOnClose() {
    return setIsOpen(false);
  };

  var handleOnOpen = function handleOnOpen() {
    return setIsOpen(true);
  };

  var links = isAuthenticated ? _Links2.popoverLinks : _Links2.guestLinks;

  var isEscapePressed = _slice.utilities.keyboard.useButtonKeys().isEscapePressed;

  if (isOpen && isEscapePressed) {
    handleOnClose();
  }

  return _react["default"].createElement(_slice.Popover, {
    clickContent: _react["default"].createElement(_Handle["default"], null),
    closeOnClickOutside: true,
    closeOnEsc: true,
    isOpen: isOpen,
    offset: [0, 4],
    onClose: handleOnClose,
    onOpen: handleOnOpen,
    placement: "bottom-end"
  }, _react["default"].createElement(Styled.Popover, null, _react["default"].createElement(_Links["default"], {
    "data-testid": "header__link",
    handleOnClose: handleOnClose,
    linkArr: links
  })));
};

var _default = Popover;
exports["default"] = _default;